"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesProviderIsNotReadyError = void 0;
var tslib_1 = require("tslib");
var StylesProviderIsNotReadyError = /** @class */ (function (_super) {
    tslib_1.__extends(StylesProviderIsNotReadyError, _super);
    function StylesProviderIsNotReadyError() {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nStylesProvider is not ready. Styles are not loaded.\nUsually this case should be unreachable.  \nIn case you face it use \"context.ready: boolean\" flag not determine if it possible to set/get params. \n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return StylesProviderIsNotReadyError;
}(Error));
exports.StylesProviderIsNotReadyError = StylesProviderIsNotReadyError;
//# sourceMappingURL=StylesProviderIsNotReadyError.js.map